import Vue from 'vue'

import axios from 'axios'

const axiosIns = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})

Vue.prototype.$http = axiosIns

axiosIns.interceptors.request.use((config) => {
    if (config.url && config.url.endsWith('/')) {
        // eslint-disable-next-line no-param-reassign
        config.url = config.url.slice(0, -1)
    }

    return config
})

export default axiosIns
